"use client";

import { createContext, useContext } from "react";

/** Resolved `{surfaceId}.field.{name}` for the active TanStackFormItem field. */
export const FieldTestIdContext = createContext<string | undefined>(undefined);

/** Modal/page surfaceId prefix from TanStackFormProvider. */
export const FormFieldTestIdPrefixContext = createContext<string | undefined>(
  undefined,
);

/** Prefer explicit testId; otherwise inherit from TanStackFormItem context. */
export function useFormControlTestId(explicit?: string): string | undefined {
  const fromField = useContext(FieldTestIdContext);
  return explicit ?? fromField;
}
